<template>
  <div class="batchGoods">
    <!-- 货品列表 -->
    <div class="goods_box">
      <div class="goods_header brl4">
        <div class="goods_header_left">
          <div class="title">
            <template v-if="info"><span class="mand-ellipsis">{{info.supplier_name}}</span><span>{{info.purchase_num | addZero}}</span></template>
            <span v-else>未选择批次</span>
          </div>
          <div class="goods_header_right" v-if="g_listQuery.batch_id">
            <button @click="handleAddGood">新增货品</button>
            <button @click="handleBatchSellOut">售罄批次</button>
            <button @click="handleShowBatchFee">费用管理</button>
            <button @click="handleToDataGoods">变更记录</button>
          </div>
        </div>
        <div class="goods_header_left">
          <div class="number" v-if="g_goodsTotal>0">共<span>{{g_goodsTotal}}</span>个商品</div>
        </div>
        <!-- <div class="goods_header_right">
          <button @click="handleAddGood">新增货品</button>
          <button @click="handleShowBatchFee">费用管理</button>
          <button @click="handleToDataGoods">变更记录</button>
        </div> -->
      </div>
      <div class="goods_tool goods_header brtl4">
        <div class="goods_header_left" v-if="g_listQuery.batch_id">
          <!-- 搜索条 -->
          <div class="list_search">
            <input
              type="text"
              v-model="g_listQuery.name"
              @input="handleBatchSearch()"
              placeholder="搜索货品名称"
            />
            <span class="icon_search">
              <md-icon name="search" size="sm" color="#888"></md-icon>
            </span>
            <span
              class="icon_close"
              v-if="g_listQuery.name"
              @click="g_listQuery.name = '';handleBatchSearch()"
            >
              <md-icon name="close" size="sm" color="#888"></md-icon>
            </span>
          </div>
        </div>
        <div class="goods_header_right" v-if="g_listQuery.batch_id">
           <!-- <el-radio-group v-model="active_btn">
            <el-radio-button label="1">补货</el-radio-button>
            <el-radio-button label="2">盘点</el-radio-button>
            <el-radio-button label="3">报损报溢</el-radio-button>
            <el-radio-button label="4">售罄</el-radio-button>
            <el-radio-button label="5">删除</el-radio-button>
          </el-radio-group> -->
          <button :class="active_btn == 1?'active':''" @click="active_btn = 1">补货</button>
          <button :class="active_btn == 2?'active':''" @click="active_btn = 2">盘点</button>
          <button :class="active_btn == 3?'active':''" @click="active_btn = 3">报损报溢</button>
          <button :class="active_btn == 4?'active':''" @click="active_btn = 4">售罄</button>
          <button :class="active_btn == 5?'active':''" @click="active_btn = 5">删除</button>
        </div>
      </div>
      <div class="goods_section" >
        <md-scroll-view
          ref="goodsScrollView"
          :scrolling-x="false"
          @refreshing="handleGoodsListRefresh"
          @end-reached="handleGoodsMore"
          v-if="g_listQuery.batch_id"
        >
          <md-scroll-view-refresh
            slot="refresh"
            slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
            :scroll-top="scrollTop"
            :is-refreshing="isRefreshing"
            :is-refresh-active="isRefreshActive"
            roller-color="#31B158"
          ></md-scroll-view-refresh>
          <div class="goods_list">
            <div
              class="goods_list_item"
              v-for="(item,index) in g_goodsList"
              :key="index"
              @click="handleDetailPop(item)"
            >
              <div class>
                <div class="list_item_line_1">
                  <div class="goods_name">
                    <span class="name mand-ellipsis">{{item.name}}</span>
                  </div>
                  <div class="goods_item_label">
                    <div class="goods_item_type">
                      <span class="goods_item_type_1" v-if="item.bale ==1">定装</span>
                      <span class="goods_item_type_2" v-if="item.bale ==2">非定装</span>
                      <span class="goods_item_type_3" v-if="item.bale ==3">散装</span>
                      <span class="goods_item_type_4" v-if="item.goods_type == 2">附加费</span>
                    </div>
                    <div class="goods_item_type mand-ellipsis">
                      <div v-if="item.goods_type == 1">
                        <span class="item_type_zy" v-if="item.type == 1">自营</span>
                        <span class="item_type_dm" v-if="item.type == 2">代卖</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list_item_line_2">
                  <div class="total">
                    <div>
                      <span class="label">进货量：</span>
                      <span v-if="item.bale == 1">{{Number(item.num)}}{{unit_list[item.num_unit - 1].name}}</span>
                      <span v-if="item.bale == 2">{{Number(item.num)}}{{unit_list[item.num_unit - 1].name}}({{Number(item.weight)}}公斤)</span>
                      <span v-if="item.bale == 3">{{Number(item.weight)}}公斤</span>
                    </div>
                    <div>
                      <span class="label">销售量：</span>
                      <span v-if="item.bale == 1">{{Number(item.xs_total_num)}}{{unit_list[item.num_unit - 1].name}}</span>
                      <span v-if="item.bale == 2">{{Number(item.xs_num)}}{{unit_list[item.num_unit - 1].name}}({{Number(item.xs_total)}}公斤)</span>
                      <span v-if="item.bale == 3" >{{Number(item.xs_total)}}公斤</span>
                    </div>
                    <div>
                      <span class="label">库存量：</span>
                      <span v-if="item.bale == 1"><span :style="Number(item.last_total_num)<0?'color:#f00':'color:#31B158'" >{{Number(item.last_total_num)}}</span>{{unit_list[item.num_unit - 1].name}}</span>
                      <span v-if="item.bale == 2"><span :style="(Number(item.lase_num)<0 || Number(item.last_total)<0)?'color:#f00':'color:#31B158'" >{{Number(item.lase_num)}}</span>{{unit_list[item.num_unit - 1].name}}(<span :style="(Number(item.lase_num)<0 || Number(item.last_total)<0)?'color:#f00':'color:#31B158'" >{{Number(item.last_total)}}</span>公斤)</span>
                      <span v-if="item.bale == 3" ><span :style="(Number(item.last_total)<0)?'color:#f00':'color:#31B158'">{{Number(item.last_total)}}</span>公斤</span>
                    </div>
                    <!-- <div>
                      <span class="label">库存量：</span>
                      <span v-if="item.bale == 1">{{Number(item.last_total_num)}}{{unit_list[item.num_unit - 1].name}}</span>
                      <span v-if="item.bale == 2">{{Number(item.lase_num)}}{{unit_list[item.num_unit - 1].name}}({{Number(item.last_total)}}公斤)</span>
                      <span v-if="item.bale == 3">{{Number(item.last_total)}}公斤</span>
                    </div> -->
                    <!-- <div class="baosun" v-if="item.damaged_num>0 || item.damaged_total > 0">
                      <span class="label">报损：</span>
                      <span v-if="item.bale == 1">{{Number(item.damaged_total_num)}}{{unit_list[item.num_unit - 1].name}}</span>
                      <span v-if="item.bale == 2">{{Number(item.damaged_num)}}{{unit_list[item.num_unit - 1].name}}({{Number(item.damaged_total)}}公斤)</span>
                      <span v-if="item.bale == 3">{{Number(item.damaged_total)}}公斤</span>
                    </div> -->
                  </div>
                </div>
                <div class="list_item_line_3">
                  <div class="date">入库时间：{{item.create_time | toTime}}</div>
                  <div class="delete">
                    <span class="success" v-if="active_btn == 1 && item.status != 2">
                      <button @click.stop="handleReplenishment(1,item)">补货</button>
                    </span>
                    <span class="success" v-if="active_btn == 2 && item.status != 2">
                      <button @click.stop="handleReplenishment(2,item)">盘点</button>
                    </span>
                    <span class="success" v-if="active_btn == 3 && item.status != 2">
                      <button @click.stop="handleReplenishment(3,item)">报损</button>
                    </span>
                    <span class="success" v-if="active_btn == 3 && item.status != 2">
                      <button @click.stop="handleReplenishment(4,item)">报溢</button>
                    </span>
                    <span class="warning" v-if="active_btn == 4 && item.status != 2">
                      <button @click.stop="handleSoldOut(item)">售罄</button>
                    </span>
                    <span class="info" v-if="active_btn == 5">
                      <button @click.stop="handleDelete(item)">删除</button>
                    </span>
                  </div>
                </div>
                <div class="list_item_line_4" v-if="item.status == 2">
                  <img src="./../../../../assets/img/work/stock/stock_saleoff.png" alt="">
                </div>
                <div class="list_item_line_5" v-if="item.status != 2" @click.stop="">
                  <el-switch
                    :value="item.status"
                    active-value="1"
                    inactive-value="3"
                    @change="handleChangeStatus(item,index)">
                  </el-switch>
                </div>
              </div>
            </div>
          </div>
          <md-scroll-view-more :finished-text="g_goodsList.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="g_isFinished"></md-scroll-view-more>
        </md-scroll-view>
      </div>
      <!-- <div class="goods_no" v-else>暂无</div> -->
    </div>
    <!-- 商品详情 -->
    <goodsDetail ref="goodsDetail" @finish="handleFinish"></goodsDetail>
    <!-- 添加商品 -->
    <addGood ref="addGood" @finish="handleFinish"></addGood>
    <!-- 费用管理 -->
    <batchFee ref="batchFee" @finish="handleFinish"></batchFee>
    <!-- 补货 -->
    <replenishment ref="replenishment" @finish="handleFinish"></replenishment>
    <!-- 盘点 -->
    <inventory ref="inventory" @finish="handleFinish"></inventory>
    <!-- 报损 -->
    <barkeGoods ref="barkeGoods" @finish="handleFinish"></barkeGoods>
    <!-- 报溢 -->
    <overflowGoods ref="overflowGoods" @finish="handleFinish"></overflowGoods>
  </div>
</template>

<script>
import goodsDetail from "./goodsDetail";
import addGood from "./addGood";
import batchFee from "./batchFee";
import replenishment from "./replenishment";
import inventory from "./inventory";
import barkeGoods from "./barkeGoods";
import overflowGoods from "./overflowGoods";
import { goods_getList ,goodsSoldOut_handle,goods_delete ,batch_sellout,goodsChangeStatus_handle} from "@/api/work/stock";
export default {
  name: "batchGoods",
  components: { goodsDetail, addGood, replenishment, inventory, barkeGoods,overflowGoods,batchFee},
  data() {
    return {
      /**
       * goods g开头
       */
      g_isFinished: false,
      g_isRefreshing: false,
      g_isRefreshActive: false,
      info:null,
      g_listQuery: {
        page: 1,
        pageSize: 15,
        batch_id: "",
        name: ""
      },
      g_goodsList: [],
      g_goodsTotal: "",

      
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],

      active_btn:4, // 商品卡片里的按钮
      
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 显示商品
    showBox(item,list) {
      this.g_listQuery.batch_id = item.id;
      this.info = item
      this.g_listQuery.name = ""
      this.g_listQuery.pageSize = 15
      this.g_listQuery.page = 1
      this.g_goodsList = list || []
      this.getGoods();
    },

    // 获取商品列表
    getGoods() {
      goods_getList(this.g_listQuery).then(res => {
        if (res.code == 200) {
          this.g_goodsTotal = res.data.totalCount;
          if (this.g_listQuery.page == 1) {
              try { this.$refs.goodsScrollView.scrollTo(0,0) } catch (error) {}
              this.g_goodsList = []
          };
          this.g_goodsList = this.g_goodsList.concat(res.data.list);
          if ( this.g_goodsList.length >= res.data.totalCount || res.data.list.length == 0 ) {
            this.g_isFinished = true;
          } else {
            this.g_isFinished = false;
            this.g_listQuery.page++;
          }
          this.$nextTick(()=>{
            if(this.g_goodsList.length > 0){
              this.$refs.goodsScrollView.finishRefresh()
              this.$refs.goodsScrollView.finishLoadMore()
            }
          })
        }
      });
    },
    // 下拉刷新数据
    handleGoodsListRefresh() {
      this.g_listQuery.page = 1;
      setTimeout(()=>{
        this.getGoods()
      },500)
    },
    // 上拉加载更多数据
    handleGoodsMore() {
      if (this.g_isFinished) {
        return
      }
      this.$refs.goodsScrollView.finishLoadMore()
      this.getGoods()
    },
    // 其他地方操作数据后的回调
    handleFinish(){
      this.g_listQuery.page = 1;
      this.getGoods()
    },
    // 搜索输入后立马查询
    handleBatchSearch() {
      this.g_listQuery.page = 1;
      this.getGoods()
    },
    // 显示详情detail
    handleDetailPop(item) {
      this.$refs.goodsDetail.showPop(this.g_listQuery.batch_id,item);
    },

    // 点击了开售停售
    handleChangeStatus(item,index){
      console.log()
      var s = item.status == 1?'下架':'上架'
      this.$dialog.confirm({
        title: "确认",
        content: `是否${s}该商品`,
        confirmText: "确定",
        onConfirm: () => {
          goodsChangeStatus_handle({goods_id:item.id,status:item.status == 1?3:1}).then(res=>{
            if(res.code == 200){
              this.$toast.succeed(res.message)
              // this.g_goodsList[index].status = String(item.status == 1?3:1 )
              this.handleFinish()
            }
          })
        }
      });
    },

    // 点击了批次售罄
    handleBatchSellOut(){
      this.$dialog.confirm({
        title: "确认",
        content: "是否售罄该批次",
        confirmText: "确定",
        onConfirm: () => {
          batch_sellout({batch_id:this.g_listQuery.batch_id}).then(res=>{
            if(res.code == 200){
              this.$toast.succeed(res.message)
              this.handleFinish()
              this.$emit("update")
            }
          })
        }
      });
    },

    // 点击了新增商品
    handleAddGood() {
      this.$refs.addGood.showPop(this.g_listQuery.batch_id);
    },
    // 点击了费用管理
    handleShowBatchFee(){
      this.$refs.batchFee.showPop(this.g_listQuery.batch_id);
    },
    // 点击了变更记录
    handleToDataGoods(){
      this.$router.push({
        path:'/stock/dataGoods',
        query:{
          batch_id:this.g_listQuery.batch_id
        }
      })
    },

    // 商品内部按钮
    // 售罄
    handleSoldOut(item) {
      this.$dialog.confirm({
        title: "确认",
        content: "是否售罄该货品",
        confirmText: "确定",
        onConfirm: () => {
          goodsSoldOut_handle({id:item.id}).then(res=>{
            if(res.code == 200 ){
              this.$toast.succeed(res.message)
              this.handleFinish()
            }
          })
        }
      });
    },
    // 商品删除
    handleDelete(item) {
      this.$dialog.confirm({
        title: "确认",
        content: "是否删除该货品",
        confirmText: "确定",
        onConfirm: () => {
          goods_delete({goods_id:item.id}).then(res=>{
            if(res.code == 200 ){
              this.$toast.succeed(res.message)
              this.handleFinish()
            }
          })
        }
      });
    },

    // 商品补货
    handleReplenishment(type,item) {
      // type  1 补货 2 盘点 3 报损 4 报溢
      var refList = ["replenishment","inventory","barkeGoods","overflowGoods"]
      this.$refs[refList[type-1]].showPop(item);
    }
  }
};
</script>

<style lang="less" scoped>
// 库存管理的样式文件
.batchGoods {
  position: relative;
  display: flex;
  height: 100%;
  overflow: hidden;
  .goods_box {
    width: 100%;
    height: 100%;
    .goods_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 0.6rem;
      padding: 0 0.16rem;
      margin-bottom: 0.1rem;
      // border-bottom: 0.1rem solid #e1e1e1;
      background-color: #fff;
      .goods_header_left {
        height: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .title {
          font-size: 0.26rem;
          height: 0.6rem;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          span{
            margin-right: 0.1rem;
            margin-top: 0.05rem;
          }
          span:nth-child(1){
            max-width: 1.8rem;
            margin-top: 0;
          }
          // line-height: 0.64rem;
        }
        .number {
          font-size: 0.24rem;
          margin-left: 0.2rem;
          // margin-right: 0.2rem;
          // color: #999;
          span{
            color: #31B158;
          }
          // line-height: 0.64rem;
        }
        .list_search {
          width: 4rem;
          height: 0.48rem;
          background-color: #fff;
          box-sizing: border-box;
          padding: 0.05rem 0;
          position: relative;
          input {
            line-height: 0.4rem;
            font-size: 0.2rem;
            border: none;
            outline: none;
            background-color: #e6e6e6;
            width: 100%;
            text-indent: 0.4rem;
          }
          span.icon_search {
            position: absolute;
            left: 0.12rem;
            top: 0.12rem;
          }
          span.icon_close {
            position: absolute;
            right: 0.12rem;
            top: 0.12rem;
          }
        }
      }
      .goods_header_right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        button {
          height: 0.36rem !important;
          line-height: 0.36rem !important;
          font-size: 0.2rem;
          padding: 0 0.15rem;
          border-radius: 0.04rem;
          color: #31b158;
          margin-left: 0.1rem;
          border: 0.01rem solid #31b158;
          font-size:0.18rem;
          box-sizing: content-box;
          background-color: #fff;
          &:active {
            color: #fff;
            background-color: #31b158;
          }
          &.active{
            color: #fff;
            background-color: #31b158;
          }
        }
      }
    }
    .goods_tool {
      height: 0.56rem;
      position: relative;
      z-index: 2;
      margin-bottom: 0;
      box-shadow: 0 0.02rem 0.06rem 0.01rem #e1e1e1;
      border-bottom: none;
      button {
        height: 0.32rem !important;
        line-height: 0.32rem !important;
        font-size: 0.18rem;
      }
      .list_search{
        height: 0.4rem !important;
        padding: 0 !important;
        span{
          top: 0.07rem !important;
        }
        .icon_search{
          left: 0.1rem !important;
        }
      }
    }
    .goods_section {
      height: calc(100% - 1.26rem);
      padding: 0 0.08rem;
      overflow: auto;
      background-color: #fff;
      .goods_list {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 0.2rem;
        .goods_list_item {
          width: 50%;
          padding: 0 0.08rem;
          margin-bottom: 0.15rem;
          position: relative;
          & > div {
            width: 100%;
            height: 100%;
            border-radius: 0.08rem;
            // border: 0.02rem solid #31b158;
            box-shadow: 0 0 0.08rem 0.02rem #e5e5e5; 
            padding: 0.1rem;
            .list_item_line_1 {
              display: flex;
              margin-bottom: 0.06rem;
              align-items: flex-end;
              justify-content: flex-start;
              .goods_name {
                max-width: 3.8rem;
                display: flex;
                justify-content: flex-start;
                align-items: flex-end;
                .name {
                  font-size: 0.24rem;
                  font-weight: bold;
                  max-width: 4rem;
                  // color: #31b158;
                }
              }
              .goods_item_label {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 0.16rem;
                .goods_item_type{
                  margin-bottom: 0.02rem;
                }
              }
            }
            .list_item_line_2 {
              display: flex;
              align-items: center;
              justify-content: space-between;
              // margin-top: 0.1rem;
              .total {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                & > div {
                  width: 100%;
                  font-size: 0.18rem;
                  line-height: 1;
                  margin: 0.05rem 0;
                  .label {
                    color: #666;
                  }
                }
              }
              .baosun{
                width: auto !important;
                position: absolute;
                right: 0.18rem;
                top: 0.06rem;
              }
            }
            .list_item_line_3 {
              font-size: 0.16rem;
              line-height: 0.24rem;
              color: #999;
              display: flex;
              align-items: flex-end;
              justify-content: space-between;
              .delete {
                position: absolute;
                right: 0.18rem;
                bottom: 0.1rem;
                span {
                  margin-left: 0.1rem;
                  button {
                    height: 0.36rem;
                    line-height: 0.36rem;
                    padding: 0 0.12rem;
                    // background-color: #31b1581f;
                    background-color: #fff;
                    border-radius: 0.04rem;
                    color: #ff0000;
                    border: 0.01rem solid #ff0000;
                    font-size: 0.2rem;
                    box-sizing: content-box;
                    &:active {
                      color: #fff;
                      background-color: #ff0000;
                    }
                  }
                  &.info button{
                      color: #999;
                      border: 0.01rem solid #999;
                      &:active{
                        color: #fff;
                        background-color: #999;
                      }
                    }
                  &.warning button{
                    color: #fa4a5e;
                    border: 0.01rem solid #fa4a5e;
                    &:active{
                      color: #fff;
                      background-color: #fa4a5e;
                    }
                  }
                  &.success button{
                    color: #31b158;
                    border: 0.01rem solid #31b158;
                    &:active{
                      color: #fff;
                      background-color: #31b158;
                    }
                  }
                }
              }
            }
            .list_item_line_4 {
              width: 0.7rem;
              height: 0.7rem;
              position: absolute;
              right: 0.88rem;
              top: 0.5rem;
              img{
                width: 100%;
              }
            }
            .list_item_line_5{
              width: auto !important;
              position: absolute;
              right: 0.18rem;
              top: 0.06rem;
            }
          }
        }
      }
    }
    .goods_no {
      line-height: 0.8rem;
      text-align: center;
      color: #999;
    }
  }
}
</style>


<style lang="less">
.batchGoods{
  .el-radio-group{
    .el-radio-button {
      .el-radio-button__inner{
        // width: 1.2rem;
        color: #999;
        font-size: 0.22rem;
        padding:0.04rem 0.2rem;
        line-height: 0.34rem;
        border-width: 0.01rem;
        border-color: #31B158;
      }
    }
  }
}
</style>